#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment eventPreview on event_Entry {
    ... baseEntryFields
    featuredImage {
        ... image
    }
    fromDate
    untilDate
    shortDescription
}
